export default function queryField() {
    return {
        restrict: 'EA',
        templateUrl: "/app/query/ocom_query/query_field.html",
        scope: {
            filterOption: '=',
            filterRow: "=",
            metaData: '=',
            specialOptions: '='
        },
        controller: function ($scope) {

            $scope.getFieldDef = function (fieldName) {
                if (!fieldName)
                    return null;

                var result = _.find($scope.metaData.fields, function (item) {
                    return (item.name == fieldName);
                })

                return result;
            }

            $scope.getOperation = function (fieldRow) {
                var result = null;

                if (fieldRow) {
                    if (!fieldRow.operation || !fieldRow.name)
                        return null;

                    var fieldDef = $scope.getFieldDef(fieldRow.name);

                    if (fieldDef) {
                        var options = $scope.filterOption[fieldDef.type];

                        result = _.find(options, function (item) {
                            return (item.code == fieldRow.operation);
                        })
                    }
                }

                return result;
            }

            $scope.updateValues = function (filterRow) {
                var newParams = [];

                var operations = $scope.getOperation(filterRow);

                if (operations) {
                    _.forEach(operations.values, function (val, index) {
                        newParams.push(filterRow.params[index]);
                    });

                    filterRow.params = newParams;
                }
            }

            $scope.getSpecialOptions = function (filterRow) {
                var fieldDef = $scope.getFieldDef(filterRow.name);

                if (fieldDef) {
                    var results = $scope.specialOptions[fieldDef.type];

                    results = _.filter(results, {param_count: filterRow.params.length});

                    return results;
                }

                return null;
            }

            $scope.setSpecial = function (filterRow, code) {
                filterRow.special = code;
            }
            $scope.getSpecialName = function (specialOptions, specialCode) {
                var result = _.find(specialOptions, function (item) {
                    return item.code == specialCode;
                });

                if (result) {
                    return result.name;
                }
                else {
                    return "";
                }
            }

            $scope.setToday = function (filterRow, index) {
                filterRow.params[index] = new Date();
            }
            $scope.clearDate = function (filterRow, index) {
                filterRow.params[index] = null;
            }
        }

    };
}